<template>
  <div>
    <h1 class="my-faq">{{ $t('FAQ') }}</h1>
    <div v-html="dataset"></div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";

export default {
  data() {
    return {
      dataset: "",
      localDisplayLangCode: localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en",
    };
  },
  methods: {
    actInitFaq(isDesktop) {
      this.$nextTick(() => {
        const buttons = document.querySelectorAll(".accordion-button");
        let currentActive = null;

        const toggleAccordion = function () {
          if (currentActive && currentActive !== this) {
            currentActive.classList.remove("active");
            currentActive.nextElementSibling.style.maxHeight = null;
            currentActive.setAttribute("aria-expanded", "false");
          }

          this.classList.toggle("active");
          const content = this.nextElementSibling;

          if (this.classList.contains("active")) {
            content.style.maxHeight = content.scrollHeight + "px";
            this.setAttribute("aria-expanded", "true");
            currentActive = this;

            setTimeout(() => {
              const rect = this.getBoundingClientRect();
              window.scrollTo({
                top: window.scrollY + rect.top - (isDesktop ? 60 : 80),
                behavior: "smooth",
              });
            }, 300);
          } else {
            content.style.maxHeight = null;
            this.setAttribute("aria-expanded", "false");
            currentActive = null;
          }
        };

        buttons.forEach((button) => {
          button.removeEventListener("click", toggleAccordion);
          button.addEventListener("click", toggleAccordion);
        });

        window.actScrollView = function () {
          const resetPassword = document.getElementById("reset-password");
          if (resetPassword) {
            buttons.forEach((button) => {
              button.classList.remove("active");
              button.nextElementSibling.style.maxHeight = null;
              button.setAttribute("aria-expanded", "false");
            });
            resetPassword.classList.add("active");
            resetPassword.nextElementSibling.style.maxHeight =
              resetPassword.nextElementSibling.scrollHeight + "px";
            resetPassword.setAttribute("aria-expanded", "true");

            setTimeout(() => {
              const rect = resetPassword.getBoundingClientRect();
              window.scrollTo({
                top: window.scrollY + rect.top - (isDesktop ? 60 : 80),
                behavior: "smooth",
              });
            }, 300);
          }
        };
      });
    },
    fetchFaqContent() {
      // Debugging: Log current language state
      console.log("fetchFaqContent called with:", {
        localDisplayLangCode: this.localDisplayLangCode,
        localStorageLang: localStorage.getItem("setDisplayLanguageCode"),
        i18nLocale: this.$i18n.locale,
      });

      // Determine FAQ URL based on language
      const isEnglish = ["en", "eng"].includes(this.localDisplayLangCode);
      const faqCode = isEnglish
        ? "https://d3k6mli483yb9r.cloudfront.net/static/mvshub/faq/en-es/faq-web.html"
        : "https://d3k6mli483yb9r.cloudfront.net/static/mvshub/faq/es-ar/faq-web.html";
      const faqMobile = isEnglish
        ? "https://d3k6mli483yb9r.cloudfront.net/static/mvshub/faq/en-es/faq.html"
        : "https://d3k6mli483yb9r.cloudfront.net/static/mvshub/faq/es-ar/faq.html";
      const urlFaq = window.screen.width > 720 ? faqCode : faqMobile;

      // Debugging: Log the URL being fetched
      console.log("Fetching FAQ from:", urlFaq);

      fetch(urlFaq)
        .then((res) => res.text())
        .then((result) => {
          this.dataset = result;
          this.actInitFaq(window.screen.width > 720);
        })
        .catch((error) => {
          console.error("Error fetching FAQ content:", error);
        });
    },
  },
  watch: {
    "$i18n.locale"(newLocale) {
      console.log("i18n.locale changed in Newversionfaq:", newLocale);
      if (this.localDisplayLangCode !== newLocale) {
        this.localDisplayLangCode = newLocale;
        this.fetchFaqContent();
      }
    },
  },
  created() {
    // Sync with i18n locale initially
    this.localDisplayLangCode =
      localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";

    // Listen for language change events
    eventBus.$on("check-local-storage", (data) => {
      console.log("check-local-storage event received:", data);
      this.localDisplayLangCode = data || this.$i18n.locale || "en";
      this.fetchFaqContent();
    });
    eventBus.$on("changeLanguageView", () => {
      console.log("changeLanguageView event received");
      this.localDisplayLangCode =
        localStorage.getItem("setDisplayLanguageCode") || this.$i18n.locale || "en";
      this.fetchFaqContent();
    });
  },
  mounted() {
    // Reset scroll position
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);

    // Initial FAQ fetch
    this.fetchFaqContent();
  },
  beforeDestroy() {
    eventBus.$off("check-local-storage");
    eventBus.$off("changeLanguageView");
  },
};
</script>

<style>
.my-faq {
    font-size: 1.5rem;
    text-align: center;
    color: rgb(119, 119, 119);
    margin-top: 4rem;
}
@media screen and (max-width: 600px) {
    .my-faq {
        margin-top: 9rem;
    }
}
</style>
